<lui-select-box-group
  [formControl]="formControl"
  [formlyAttributes]="field"
  [multiple]="props.multiple"
  [required]="$any(props.required)"
  [class.lui-select-box-group-readonly]="props.readonly"
>
  <div class="row g-1">
    <ng-container
      *ngIf="
        props.options | formlySelectOptions : field | async as selectOptions
      "
    >
      <ng-container *ngFor="let item of selectOptions; let index = index">
        <div
          class="d-flex"
          [ngClass]="{
            'col-12': columns === 1,
            'col-6': columns === 2,
            'col-4': columns === 3
          }"
        >
          <lui-select-box
            [value]="item.value"
            [readonly]="props.readonly"
            [disabled]="item.disabled"
            [beforeSelect]="beforeSelect"
            class="h-100 flex-1"
          >
            <span [innerHTML]="item.label"></span>
          </lui-select-box>
          <div
            class="ms-_5 d-flex"
            *ngIf="props.tooltips?.[item.value] as tooltip"
          >
            <lui-avatar color="primary" [size]="20" [matTooltip]="tooltip.text">
              <mat-icon svgIcon="i"></mat-icon>
            </lui-avatar>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</lui-select-box-group>
